import { render, staticRenderFns } from "./PersonProfileHistoryLocationInfoRow.vue?vue&type=template&id=777f64f9&scoped=true&"
import script from "./PersonProfileHistoryLocationInfoRow.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryLocationInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryLocationInfoRow.vue?vue&type=style&index=0&id=777f64f9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f64f9",
  null
  
)

export default component.exports